import {ELocalStoreKeys} from '../models/consts';

/** Google Click ID max length; Cognito clientMetadata value limit is 2048. */
const GCLID_MAX_LENGTH = 500;

function isValidGclid(value: string): boolean {
  return value.length > 0 && value.length <= GCLID_MAX_LENGTH && /^[\w.-]+$/.test(value);
}

/** Persist gclid from the current URL (`?gclid=`) into localStorage. */
export function captureGclidFromUrl(searchParams: URLSearchParams = new URLSearchParams(window.location.search)): void {
  const gclid = searchParams.get('gclid')?.trim();
  if (!gclid || !isValidGclid(gclid)) {
    return;
  }
  try {
    localStorage.setItem(ELocalStoreKeys.GCLID, gclid);
  } catch {
    // ignore quota / private mode
  }
}

export function getStoredGclid(): string | undefined {
  try {
    const gclid = localStorage.getItem(ELocalStoreKeys.GCLID)?.trim();
    if (gclid && isValidGclid(gclid)) {
      return gclid;
    }
  } catch {
    // ignore
  }
  return undefined;
}

export function clearStoredGclid(): void {
  try {
    localStorage.removeItem(ELocalStoreKeys.GCLID);
  } catch {
    // ignore
  }
}
